exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".project-copy-form-group {\n  white-space: nowrap; }\n\n.MuiDialog-paperWidthSm {\n  max-width: 9999999px !important; }\n\n.project-copy-input {\n  width: 75%; }\n", ""]);

